import { Button } from '@cube3/cubicle/src/core/atoms/Button';
import { Password } from '@cube3/cubicle/src/core/atoms/InputField/Password';
import { HBox, VBox } from '@cube3/cubicle/src/core/templates/layout/Flex';
import { SizeVariants } from '@cube3/cubicle/src/theme/themes';
import React, { useCallback } from 'react';
import { passwordValidator } from '../../../../forms/helpers/validators';
import { generatePassword } from '@cube3/common/utils/generatePassword';
import { isMobile } from 'react-device-detect';

export const PasswordRow = (props) => {
  const { value, onChange, touched, label } = props;

  const onCopyPassword = useCallback(() => {
    if (value) {
      navigator.clipboard.writeText(value);
    }
  }, [value]);

  return (
    <>
      {!isMobile ? (
        <HBox justify="start" align="baseline" gap={8}>
          <Password
            startVisible={true}
            value={value}
            onChange={onChange}
            placeholder={!touched ? `●●●●●●` : `${label}...`}
          />

          <Button
            size={SizeVariants.sm}
            iconRight={'clipboard'}
            onClick={onCopyPassword}
            disabled={!value}
            buttonStyle="ghost"
            background="secondary"
          >
            Copy
          </Button>

          <Button
            buttonStyle="ghost"
            background="secondary"
            iconRight={'refresh'}
            size={SizeVariants.sm}
            onClick={() => onChange(generatePassword(passwordValidator))}
          >
            New
          </Button>
        </HBox>
      ) : (
        <VBox justify="start" align="baseline" gap={8}>
          <Password
            startVisible={true}
            value={value}
            onChange={onChange}
            placeholder={!touched ? `●●●●●●` : `${label}...`}
          />

          <HBox>
            <Button
              size={SizeVariants.lg}
              iconRight={'clipboard'}
              onClick={onCopyPassword}
              disabled={!value}
              buttonStyle="ghost"
              background="secondary"
            >
              Copy
            </Button>

            <Button
              buttonStyle="ghost"
              background="secondary"
              iconRight={'refresh'}
              size={SizeVariants.lg}
              onClick={() => onChange(generatePassword(passwordValidator))}
            >
              New
            </Button>
          </HBox>
        </VBox>
      )}
    </>
  );
};
